document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Blog animations loaded");

    // Select or create progress bar
    let progressBar = document.getElementById("scrollProgress");
    if (!progressBar) {
        progressBar = document.createElement("div");
        progressBar.id = "scrollProgress";
        progressBar.style.position = "fixed";
        progressBar.style.top = document.querySelector("header").offsetHeight + "px";
        progressBar.style.left = "0";
        progressBar.style.width = "8px";
        progressBar.style.height = "0";
        progressBar.style.background = "linear-gradient(to bottom, #e5f1e8, #cad7ce)";
        progressBar.style.zIndex = "9999";
        progressBar.style.pointerEvents = "none";
        document.body.appendChild(progressBar);
    }

    // Find the correct elements
    const header = document.querySelector("header, .site-header, .shopify-section-header, .main-header");
    const article = document.querySelector(".article"); // Updated to select `.article`

    if (!article || !header) {
        console.warn("⚠ Article or Header not found. Hiding progress bar.");
        progressBar.style.display = "none";
        return;
    }

    function updateProgressBar() {
        const headerHeight = header.offsetHeight;
        const articleTop = article.offsetTop - headerHeight;
        const articleBottom = articleTop + article.offsetHeight;
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;

   if (scrollY > articleTop) {
    const totalScroll = articleBottom - articleTop - windowHeight;
    const scrolled = scrollY - articleTop;
    let progressHeight = (scrolled / totalScroll) * windowHeight;

    // Ensure the progress bar stays full once past the article
    if (scrollY >= articleBottom - windowHeight) {
        progressHeight = windowHeight; // Keep it fully visible
    }

    progressBar.style.height = `${Math.max(progressHeight, windowHeight * 0.02)}px`; // Minimum height to prevent sticking
} else {
    progressBar.style.height = "0px"; // Reset when scrolled to the very top
}


    }

    document.addEventListener("scroll", updateProgressBar);
    window.addEventListener("resize", updateProgressBar);

    console.log("🚀 Scroll Progress Bar Script Initialized Successfully");
});

